import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrderList(obj) {
    var payload = await GetSeferData("rf11", obj);
    return (payload);
}
export async function getFilterMeta(){
    var payload = await GetSeferData("rfaux7", {});
    return (payload);
}
export async function getClassSpreadSheet(obj) {
    var payload = await GetSeferData("rf12", obj);
    return (payload);
}